// extracted by mini-css-extract-plugin
export default {"skipped":"NavBar_skipped__+tKru","answered":"NavBar_answered__E5BoM","notAnswered":"NavBar_notAnswered__frRLG","active":"NavBar_active__tCd8u"};